import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'aasa-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() message: string = 'Cargando';
  constructor() {}

  ngOnInit(): void {}
}
